import { defineTerm, getTermRange, defineRange, resolveCycleWindow } from '@magmacomputing/tempo/plugin-api';
/** definition of daily time periods */
const groups = defineRange([
    { key: 'Midnight', locale: { fr: 'Minuit', es: 'Medianoche', de: 'Mitternacht' }, hour: 0, group: 'standard' },
    { key: 'Early', locale: { fr: 'Tôt', es: 'Temprano', de: 'Früh' }, hour: 4, group: 'standard' },
    { key: 'Morning', locale: { fr: 'Matin', es: 'Mañana', de: 'Morgen' }, hour: 8, group: 'standard' },
    { key: 'Midmorning', locale: { fr: 'Milieu de la matinée', es: 'Media mañana', de: 'Vormittag' }, hour: 10, group: 'standard' },
    { key: 'Midday', locale: { fr: 'Midi', es: 'Mediodía', de: 'Mittag' }, hour: 12, group: 'standard' },
    { key: 'Afternoon', locale: { fr: 'Après-midi', es: 'Tarde', de: 'Nachmittag' }, hour: 15, minute: 30, group: 'standard' },
    { key: 'Evening', locale: { fr: 'Soir', es: 'Noche', de: 'Abend' }, hour: 18, group: 'standard' },
    { key: 'Night', locale: { fr: 'Nuit', es: 'Noche', de: 'Nacht' }, hour: 20, group: 'standard' },
], 'group');
function resolve(t, anchor) {
    return resolveCycleWindow(t, groups, { anchor, groupBy: ['group'], group: 'standard' });
}
export const TimelineTerm = defineTerm({
    key: 'tod',
    scope: 'timeOfDay',
    description: 'Daily time period',
    groups,
    resolve(anchor) {
        return resolve(this, anchor);
    },
    define(keyOnly, anchor) {
        return getTermRange(this, resolve(this, anchor), keyOnly, anchor);
    }
});
